import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

const saved = typeof window !== "undefined" ? localStorage.getItem("fc_token") : null;
if (saved) {
  api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;
}

export function setToken(token) {
  if (token) {
    localStorage.setItem("fc_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("fc_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export default api;
